import React from 'react'
import successIcon from "../assets/images/success.svg"

const LoginSuccess = () => {
  return (
    <div className='form_box_success'>
            <div className='success_main'>
                <img className='success_icon' src={successIcon} alt='success' />
                <h2 style={{textAlign:'center'}} className='box_head'>הכניסה מוצלחת</h2>
                <p className='success_desc'>נכנסת בהצלחה לחשבון שלך. אתה יכול לסגור חלון זה ולהמשיך להשתמש במוצר.</p>
            </div>
            <button className='login_btn'>סגור חלון</button>
    </div>
  )
}

export default LoginSuccess